export default "__VITE_ASSET__2ca9254e__"